module.exports = "https://static.wmbcdn.com/uniweb/images/02eb8d805d8ce049bd651a8e4c13e43f.svg";